<h2 mat-dialog-title class="lmc-dialog-title">Upload ACH File</h2>

<mat-dialog-content>
    <p class="lmc-dialog-description">Select the fund type for this ACH file.</p>

    <form [formGroup]="form" class="ach-form">

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Fund Type</mat-label>
            <mat-select formControlName="originatorType">
                <mat-option *ngFor="let type of originatorTypes" [value]="type.value">
                    {{ type.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('originatorType')?.hasError('required')">
                Fund type is required.
            </mat-error>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onConfirm()">
        Continue
    </button>
</mat-dialog-actions>